import {AppBar, Button, IconButton, Toolbar, Typography} from "@material-ui/core";
// import classes from "./FrontHeader.module.css";
import MenuIcon from '@material-ui/icons/Menu';
import {makeStyles} from "@material-ui/core/styles";
import AppLogo from "../../../components/AppLogo/AppLogo";
import {Link} from "react-router-dom";

const useStyle = makeStyles({
    root: {
        flexGrow: 1,
    },
    frontHeader: {},
    title: {},
    menuButton: {
        color: 'white',
    },
    appBar: {
       position: 'absolute',
        top: 0,
        left: 0,

    }
})

export const FrontHeader = () => {
    const classes = useStyle();
    return (
        <div className={classes.root}>
            <AppBar position="static" color={"transparent"} className={classes.appBar}>
                <Toolbar color={'primary'}>
                    <AppLogo/>
                    <div className={classes.root}/>
                    <Typography variant="h6" className={classes.title} color={'primary'}>
                        <Button className={classes.menuButton} component={Link} to={'/admin'}>ADMIN</Button>
                        <Button className={classes.menuButton} component={Link} to={'/parent'}>PARENT</Button>
                        <Button className={classes.menuButton} component={Link} to={'/kid'}>KID</Button>
                    </Typography>
                    {/*<IconButton edge="start" className={classes.menuButton} color="default" aria-label="menu">*/}
                    {/*    <MenuIcon/>*/}
                    {/*</IconButton>*/}
                </Toolbar>
            </AppBar>
        </div>)
}
